<template>
  <article class="diff-card">
    <div class="d-flex flex-column align-items-start diff-card-container">
      <h3>{{ article.title }}</h3>
      <RectAngleShape class="w-100" />
      <img :src="article.img.link" :alt="article.img.alt" class="card-img mt-2 fit-cover w-100" width="220" height="160">
      <p v-html="article.description" class="flex-stretch"></p>
      <ButtonTransparent class="diff-card__btn" v-if="article.button.text && article.button.link" :text="article.button.text" hyperlink :href="article.button.link" />
    </div>
  </article>
</template>

<script>
import CardImg from '@/assets/images/shutterstock-706431193.jpg'
import RectAngleShape from "@/components/common/RectAngleShape";
import ButtonTransparent from "@/components/common/ButtonTransparent";

export default {
  components: {ButtonTransparent, RectAngleShape, CardImg},
  props: {
    article: {
      title: String,
      description: String,
      img: {
        link: String,
        alt: String
      },
      button: {
        text: String,
        link: String
      }
    }
  }
}
</script>
